import { Pencil } from "lucide-react"

const HowToModifyUsers = () => (
  <div>
    <ol className="list-decimal list-inside text-grays-dark space-y-4">
      <li>
        Visit{' '}
        <a className="underline text-blue-800" href="http://ctionline.com/">
          CTI Online
        </a>
      </li>
      <li>
        Click <strong>Sign In</strong>
      </li>
      <li>
        Click the <strong>Account</strong> icon in the top right corner of the page then
         select <strong>Admin</strong>
        <div className="my-4 border rounded">
          <img src="/images/faqs/ham_menu_hided.png" alt="Admin Panel" />
        </div>
      </li>
      <li>
        Click on <strong>Admin</strong> then click on <strong>Manage Users</strong>
        <div className="my-4 border rounded">
          <img src="/images/faqs/Manage_Users1.png" alt="Courses to start" />
        </div>
      </li>
      <li>Click on <strong>Users</strong> and then <strong>+Add User</strong> and fill out all required fields</li>
      <li>
        Click on <strong>Add User</strong> to complete the process
      </li>
      <li className="list-decimal list-inside">
        To modify an existing user, select {" "}
        <span className="inline-flex align-middle">
          <button
            className="flex items-center gap-1 text-xs font-bold px-3 py-1.5 
                      rounded bg-blue-100 text-blue-700 border border-blue-300 cursor-default"
          >
            <Pencil className="w-3 h-3" />
          </button>
        </span>{" "}
        user from the list and make changes to their profile, then click
        <strong> Save</strong>.
      </li>
      <li>
        To deactivate an existing user uncheck the <strong>Active</strong> box,
        then click <strong>Save</strong>
        <div className="my-4 border rounded">
          <img src="/images/faqs/Deactive_User1.png" alt="Deactivate User" />
        </div>
      </li>
    </ol>
  </div>
)

export default HowToModifyUsers
